import React from 'react';

import Mark from 'components/Tvendo/Article/DataMaster/Mark/List.js';

export default function () {
  return <Mark />;
}
